var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "10",
        height: "15",
        viewBox: "0 0 10 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.28326 3.32166L2.28761 5.47818C1.94761 5.82166 1.39804 5.82166\n        1.05804 5.47818C0.718043 5.13383 0.718043 4.57644 1.05804 4.23296L4.22935 0.886005C4.4763 0.63731 4.80239\n        0.499919 5.15196 0.499919C5.50065 0.499919 5.82848 0.63731 6.0737 0.886005L9.245 4.23296C9.585 4.57644 9.585\n        5.13383 9.245 5.47818C8.90587 5.82166 8.35543 5.82166 8.01543 5.47818L6.02239 3.3234L6.02239 13.5364C6.02239\n        14.0164 5.63283 14.406 5.15283 14.406C4.67283 14.406 4.28326 14.0164 4.28326 13.5364L4.28326 3.32166Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }